import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { GdataHeader } from '../molecules/GdataLayout/GdataHeader';

const GdataLayout = () => {
  return (
    // The worklist is a light-themed surface. OHIF 3.10's @ohif/ui-next base
    // stylesheet forces `body { @apply !bg-black }` for the dark viewer, so paint
    // an explicit light background (with dark text) over it here — otherwise the
    // worklist pages render black-on-black.
    //
    // `gleamer-worklist-surface` (min-width: min-content) matters: as a plain
    // block this div is only as wide as the viewport, so once the content
    // overflows horizontally (narrow tablet widths) scrolling right ran past the
    // white background and exposed that black body. It's plain CSS rather than
    // Tailwind's `min-w-max` because the active ui-next stylesheet doesn't scan
    // `gleamer/*` — a utility only we use gets purged (verified: `min-w-max` was
    // absent from the built CSS, which is why the class alone didn't work).
    <div className="gleamer-worklist-surface min-h-screen bg-white text-black">
      <GdataHeader />
      <div className="p-4">
        <Outlet />
      </div>
    </div>
  );
};
export default withAuthenticationRequired(GdataLayout);
